import { Button, Form, Input, Select, message } from 'antd';
import axios from 'axios';
import React from 'react';

function AddPolka({ sections, setR, r }) {
    const [form] = Form.useForm();

    return (
        <Form form={form} layout="vertical" onFinish={(values) => {
            axios.post('shelves', values).then(() => {
                message.success("Polka muvaffaqiyatli qo'shildi");
                form.resetFields();
                setR(!r);
            }).catch(() => {
                message.error("Polka qo'shishda xatolik");
            });
        }}>
            <Form.Item label="Seksiya" name="section_id" rules={[{ required: true, message: "Seksiyani tanlang" }]}>
                <Select placeholder="Seksiyani tanlang" options={sections.map((sec) => ({ label: sec.name, value: sec.id }))} />
            </Form.Item>
            <Form.Item label="Polka nomi" name="name" rules={[{ required: true, message: "Nom kiritilishi shart" }]}>
                <Input placeholder="Polka nomini kiriting" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" block>Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default AddPolka;